import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-blue-50 via-white to-red-50 pt-24 pb-16 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Zap" size={16} />
            <span>Interactive Platform Experience</span>
          </div>
          
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
            Experience Real-Time Policy Monitoring
          </h1>
          
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto mb-8 md:mb-10">
            Explore how PolicyAlerts transforms medical policy complexity into actionable intelligence with our interactive platform demonstration. No login required.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button 
              variant="default" 
              size="lg"
              iconName="Play"
              iconPosition="left"
            >
              Start Interactive Demo
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              iconName="Calendar"
              iconPosition="left"
            >
              Schedule Live Walkthrough
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-4xl mx-auto">
          <div className="bg-card border border-border rounded-lg p-4 md:p-6 text-center">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3 md:mb-4">
              <Icon name="Bell" size={24} color="var(--color-primary)" />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">Real-Time Alerts</h3>
            <p className="text-sm text-muted-foreground">Instant notifications for critical policy changes</p>
          </div>

          <div className="bg-card border border-border rounded-lg p-4 md:p-6 text-center">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-secondary/10 rounded-lg flex items-center justify-center mx-auto mb-3 md:mb-4">
              <Icon name="Search" size={24} color="var(--color-secondary)" />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">Smart Filtering</h3>
            <p className="text-sm text-muted-foreground">Policy-specific search and categorization</p>
          </div>

          <div className="bg-card border border-border rounded-lg p-4 md:p-6 text-center">
            <div className="w-12 h-12 md:w-14 md:h-14 bg-accent/10 rounded-lg flex items-center justify-center mx-auto mb-3 md:mb-4">
              <Icon name="TrendingUp" size={24} color="var(--color-accent)" />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">Impact Analysis</h3>
            <p className="text-sm text-muted-foreground">Policy impact assessments and coverage trends</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;